import { Route } from "react-router-dom";
import lazyRoute, { SuspendedRoute } from "@/router/lazy-route";
import lazyWithRetry from "@/utils/lazy-with-retry";
import { PatientChartClinicalRoutes } from "./PatientChartClinicalRoutes";
import { PatientChartFinancialRoutes } from "./PatientChartFinancialRoutes";

const PatientChartNewLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/PatientChartNewLayout")
);
const PatientChat = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientChat")
);
const PatientCommunicationLayoutNewChart = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientCommunicationLayoutNewChart")
);
const PatientEmailTable = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientEmailTable")
);
const PatientPortalAccess = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/access/PatientAccess")
);
const DemoGraphicsLayoutNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/demographics/DemoGraphicsLayout")
);
const DemographicsNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/demographics/DemographicsNew")
);
const PatientEligibility = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/demographics/eligibility/PatientEligibility")
);
const PatientEducationMaterial = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/education-material/PatientDocLayout")
);
const PatientChartForms = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/forms/PatientChartForms")
);
const HistoryLayoutNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/history/HistoryLayoutNew")
);
const PastMedicalHistoryNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/history/PastMedicalHistory")
);
const PastSurgicalHistoryNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/history/PastSurgicalHistory")
);
const PatientFamilyHistoryNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/history/PatientFamilyHistory")
);
const SocialHistoryNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/history/SocialHistoryNew")
);
const PatientOrderNewLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/PatientOrderLayout")
);
const PatientOrderNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNew")
);
const OrderPrescriptionNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/prescription/OrderPrescriptionNew")
);
const OderResultNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/result/OderResultNew")
);
const PatientChronologicalAndRequiringActionLayout = lazyWithRetry(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/patient-chronological-records-and-requiring-actions/patientChronologicalAndRequiringActionLayout")
);
const PatientTask = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/tasks/PatientTask")
);
const PatientVisitHistory = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/visit-history/PatientVisitHistory")
);
const PatientAssementForms = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/PatientAssementForms")
);
const PatientAssementLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/PatientAssementLayout")
);
const PatientSendAssessments = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/SchedulePatientAssementForms")
);
const PatientChartAssessment = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientChartAssessment")
);
const ScheduledAssessment = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/ScheduledAssessment")
);
const ScreeningAssessment = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/ScreeningAssessment")
);
const ScreeningTable = lazyRoute(() =>
  import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/ScreeningAssessment").then(
    (m) => ({ default: m.ScreeningTable })
  )
);
const AssessmentSummaryLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/assessment/summary/AssessmentSummaryLayout")
);
const PatientInsuranceNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/demographics/insurance/PatientInsuranceNew")
);
const PatientEncounter = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientEncounter")
);
const PatientCallTable = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientCallTable")
);
const PatientVisitNoteLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientVistNoteLayoutNew")
);
const PatientReferral = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/referral/PatientReferral")
);
const Authorization = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart/demographics/authorization/Authorization")
);

export const PatientChartRoutes = () => (
  <Route path=":patientId" element={<PatientChartNewLayout />}>
    <Route
      path="index"
      element={
        <SuspendedRoute>
          <PatientChronologicalAndRequiringActionLayout />
        </SuspendedRoute>
      }
    />
    <Route path="financial" element={"financial"} />
    <Route path="forms" element={<PatientChartForms />} />
    <Route path="assessment" element={<PatientChartAssessment />}>
      {/* <Route index element={<CompletedAssessment />} /> */}
      <Route index element={<AssessmentSummaryLayout />} />
      <Route path="screening" element={<ScreeningAssessment />}>
        <Route index element={<ScreeningTable />} />
        {/* <Route path="start-new" element={<ScreeningStartNewLayout />} /> */}
      </Route>
      <Route path="scheduled" element={<ScheduledAssessment />} />

      <Route path="assessments" element={<PatientAssementLayout />}>
        <Route index element={<PatientAssementForms />} />
        <Route path="schedule" element={<PatientSendAssessments />} />
      </Route>
    </Route>
    <Route
      path="communication"
      element={<PatientCommunicationLayoutNewChart />}
    >
      {/* Todo: need to add sms table back */}
      {/* <Route index element={<PatientSMSTable />} /> */}
      <Route index element={<PatientChat />} />
      <Route path="email" element={<PatientEmailTable />} />
      <Route path="call" element={<PatientCallTable />} />
    </Route>
    <Route path="tasks" element={<PatientTask />} />
    <Route path="referral" element={<PatientReferral />} />
    {/* note : this route has updated to patient education material  due to merger of documents and education material */}
    <Route path="documents" element={<PatientEducationMaterial />} />
    <Route path="history" element={<HistoryLayoutNew />}>
      <Route index element={<PastMedicalHistoryNew />} />
      <Route path={"surgical"} element={<PastSurgicalHistoryNew />} />
      <Route path={"family"} element={<PatientFamilyHistoryNew />} />
      <Route path={"social"} element={<SocialHistoryNew />} />
    </Route>
    <Route path="prescription" element={<OrderPrescriptionNew />} />
    <Route path="order" element={<PatientOrderNewLayout />}>
      <Route index element={<PatientOrderNew />} />
      <Route path="result" element={<OderResultNew />} />
    </Route>
    <Route path="visit-history" element={<PatientVisitHistory />} />
    <Route path="visit-note" element={<PatientVisitNoteLayout />}>
      <Route path="form" element={<PatientEncounter />}>
        <Route
          index
          element={
            <SuspendedRoute>
              <PatientChronologicalAndRequiringActionLayout
                shouldHideCreateVisitNote
              />
            </SuspendedRoute>
          }
        />
      </Route>
    </Route>
    <Route path="demographics" element={<DemoGraphicsLayoutNew />}>
      <Route index element={<DemographicsNew />} />
      <Route path="insurance" element={<PatientInsuranceNew />} />
      <Route path="eligibility" element={<PatientEligibility />} />
      <Route path="authorization" element={<Authorization />} />
      <Route path="portal-access" element={<PatientPortalAccess />} />
    </Route>
    {PatientChartFinancialRoutes()}
    {PatientChartClinicalRoutes()}
  </Route>
);
